import type { RuleDefinition } from "../ruleRegistry";

export const FRAMING_RULES = [
	{
		id: "framing.ccMm",
		category: "framing",
		label: "c/c avstånd",
		description: "Center-center avstånd mellan stående reglar.",
		defaultValue: 600,
		valueType: "number",
		unit: "mm",
		source: "BBR / Svensk standard",
	},
	{
		id: "framing.studWidthMm",
		category: "framing",
		label: "Regelbredd",
		description: "Regelns bredd (kortsida).",
		defaultValue: 45,
		valueType: "number",
		unit: "mm",
	},
	{
		id: "framing.studDepthMm",
		category: "framing",
		label: "Regeldjup",
		description: "Regelns djup (långsida, 45×95).",
		defaultValue: 95,
		valueType: "number",
		unit: "mm",
	},
	{
		id: "framing.headerSpanTable",
		category: "framing",
		label: "Avväxlings-spännviddstabell",
		description:
			"JSON-tabell som mappar fönsterbredd (mm) till erforderligt avväxlingsdjup (mm). Systemet rundar upp till närmast större spännvidd.",
		defaultValue: { "600": 95, "900": 140, "1200": 190, "1500": 220 },
		valueType: "json",
		source: "Svenskt Trä spännviddstabeller",
		dangerLevel: "critical",
	},
	{
		id: "framing.minCornerClearanceMm",
		category: "framing",
		label: "Min hörnfri zon",
		description:
			"Minsta avstånd i mm mellan öppningens kant och vägghörn på ytterväggar, så foder inte kolliderar med knutbrädor (uppmätt kollisionsfritt avstånd: ~150mm fyrkantig, ~90mm tvårum; ingen kollision vid 200mm+). Gäller inte innerväggar (mellanvägg) som saknar knutbrädor.",
		defaultValue: 150,
		valueType: "number",
		unit: "mm",
	},
	{
		id: "framing.defaultWindowSillHeightMm",
		category: "framing",
		label: "Standard fönsterbröstning",
		description:
			"Standardhöjd i mm för fönsterbröstning (underkant fönster från golv) vid ny fönsterplacering.",
		defaultValue: 900,
		valueType: "number",
		unit: "mm",
		source: "BBR",
	},
] as const satisfies readonly RuleDefinition[];
